import styled from 'styled-components';
import {
  Loader as LoaderLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  padding: 54px 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Loader = styled(LoaderLayoutComponent)`
  align-self: center;

  &&&:last-child {
    margin-top: 20px;
  }
`;

export const VideoContainer = styled.div`
  flex: 1;
`;

export const Message = styled(TextLayoutComponent)`
  margin-bottom: 40px;
  max-width: 600px;
  font-size: 18px;
  text-align: center;
`;

export const ContainerMessage = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const MessageImage = styled.img`
  margin-bottom: 20px;
`;

export const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
